<template>
    <div class="tsa-selectv2-container">
        <el-select
            v-model="selectValue"
            :placeholder="placeholder"
            clearable
            :filterable="filterable"
            :disabled="disabled"
            class="tsa-selectv2"
            @change="change"
            popper-class="tsa-selectv2-popper"
        >
            <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="exportFiled === 'value' ? item.value : item[exportFiled]">
            </el-option>
        </el-select>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: String | Number | null | Array,
            default: null
        },
        options: {
            type: Array,
            default: () => []
        },
        placeholder: {
            type: String,
            default: '请选择'
        },
        disabled: {
            type: Boolean,
            default: false
        },
        exportFiled: {
            type: String,
            default: 'value'
        },
        multiple: {
            type: Boolean,
            default: false
        },
        filterable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            selectValue: ''
        }
    },
    watch: {
        value (val) {
           this.selectValue = val
        }
    },
    created () {
        this.selectValue = this.value
    },
    methods: {
        change (value) {
            if (this.multiple) {
                this.$emit('input', value === '' ? [] : value)
                this.$emit('on-change', value === '' ? [] : value)
            } else {
                this.$emit('input', value === '' ? null : value)
                this.$emit('on-change', value === '' ? null : value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
// 自定义select样式
.tsa-selectv2-container {
    position: relative;
    /deep/.el-select {
        &.tsa-selectv2 {
            width: 100%;
            .el-input__inner {
                font-size: 14px;
                color: #151B26;
                height: 32px!important;
                background: #FFFFFF;
                border-radius: 6px;
                border: 1px solid #D4D6D9;
            }
            .el-input {
                &.is-focus {
                    .el-input__inner {
                        border: 1px solid #2468F2;
                    }
                }
                &.is-disabled {
                    .el-input__inner {
                        background-color: #F5F7FA;
                        border-color: #E4E7ED;
                        color: #C0C4CC;
                        cursor: not-allowed;
                    }
                }
            }
            .el-input__suffix {
                .el-select__caret {
                    color: #999A9F;
                    line-height: 32px;
                    font-size: 14px;
                }
            }
        }
    }
}


.el-select-dropdown {
    &.tsa-selectv2-popper{
        .el-select-dropdown__item {
            font-size: 14px;
            color: #151B26;
            &.selected{
                color: #2468F2;
            }
            &:hover {
                background-color: #E6F0FF;
            }
        }
    }
}
</style>